<template>
<div class="mOrderHeader" @click="handleCourseView">
    <div class="left"><img class="img" v-lazy="item.coverurl || item.logourl" alt=""></div>
    <div class="right">
        <div class="title">{{item.subject || item.kmcname}}</div>
        <div class="expiredays" v-if="item.kmctype === 7 && item.isbuyexpire">自购买之日起{{item.expiredays}}天内有效</div>
    </div>
</div>
</template>

<script>
  import {mapActions} from 'vuex'
export default {
    name: 'mOrderHeader',
    props: ['item'],
    data() {
        return {}
    },
    methods: {
        handleCourseView() {
            if(this.item.kmctype===7){
                this.$router.push({name: 'MCourseView', query: {cid: this.item.courseid}})
            }else if(this.item.kmctype===8){
                this.$router.push({name: 'PaperDetails', query: {qid: this.item.courseid}});
            }else if(this.item.kmctype===13){
              this.setRefresh(true)
              this.$router.push({name: 'ActivityDetail', query: {eventid: this.item.courseid}})
            }else{
                this.$router.push({name: 'MReportDetails', query: {reportid: this.item.courseid}})
            }
            this.setRefresh(true)
        },
      ...mapActions(['setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mOrderHeader {
    display: flex;
    justify-content: flex-start;
    font-size:0.28rem;
    font-weight: 600;
    padding: 0.32rem;
    // margin-top: 0.2rem;
    background: $c-white;
    .left{
        min-width:2.6rem;
        max-width: 2.6rem;
        width: 2.6rem;
        height: 1.46rem;
        margin-right:0.2rem;
        .img{
            width: 100%;
            height: 100%;
            border-radius: 0.06rem;
        }
    }
    .right{
        width: 4.84rem;
        .title{
            height: 0.8rem;
            line-height: 0.4rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            font-weight: bold;
        }
        .expiredays {
            font-size: 0.28rem;
            color: #EC5E69;
            margin-top: 0.2rem;
            line-height: 0.4rem;
        }
    }
}
</style>